import type { AccountRole } from "@/features/accounts/api/accountsApi";

const ROLE_LABEL: Record<AccountRole, string> = {
  owner: "Owner",
  admin: "Admin",
  operator: "Operador",
  viewer: "Visor",
};

const ROLE_CLASS: Record<AccountRole, string> = {
  owner: "bg-violet-100 text-violet-800",
  admin: "bg-blue-100 text-blue-800",
  operator: "bg-amber-100 text-amber-800",
  viewer: "bg-neutral-100 text-neutral-600",
};

export function RoleBadge({ role }: { role: AccountRole }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 font-medium text-xs ${ROLE_CLASS[role]}`}
    >
      {ROLE_LABEL[role]}
    </span>
  );
}
